import { sclHandlebars } from '../../../../formbird-sc-shared/src/lib/handlebars/sclHandlebars';
import {DataTableSelect} from './datatables.select';

const logger = console;
declare var $;

export class DataTableEvents {

  constructor() {}

  draw(dt) {
    if (dt.rowGroup) {
        $(dt.dtWrapper.nativeElement).find('tbody tr:visible:odd').addClass('group-odd');
        $(dt.dtWrapper.nativeElement).find('tbody tr:visible:even').addClass('group-even');
    }

    const info = dt.table.page.info();
    if( dt.pagination.isDeep ){
      dt.goDeepCallback(dt.pagination.last_page + 1);
    }else{
      dt.goToCallback(dt.pagination.current_page);
    }
  }

  reload(dt) {
    if (dt.dataSource === 'internal') {
      dt.utilSharingNgService.fnCallFunction(dt.fieldName, 'eventReloadDatatable', null, null);
    } else {
      if (dt.table) {
        /*const sortOrder = [];
        dt.columnSort.forEach((val, i) => {
          sortOrder.push([val.index, val.direction]);
        });
        dt.table.order(sortOrder).draw();*/
        dt.table.ajax.reload(null, false);
      }
    }
  }

  order(dt) {
    const headItems = dt.table.columns().header();
    const eleSort = $(headItems).find('sub.dt-sort-priority-number');
    $(eleSort).remove();

    const order = dt.table.order();
    if (order.length > 1) {
      order.forEach((value, index) => {
        const headItem = dt.table.columns(value[0]).header();
        const eleSort1 = $('<sub class="dt-sort-priority-number">' + (index + 1) + '</sub>');

        if ($(headItem).find('.rotate').length > 0) {
          $(headItem).find('.rotate').append(eleSort1)
        }else{
          $(headItem).append(eleSort1);
        }
      });
    }
  }

  pageLength(length, dt) {
    dt.initComplete = false;
    dt.table.page.len(length).draw();
    dt.detectChanges();
  }

  select(dt, indexes) {
    if( window.getSelection().toString() !== '' ){
      return;
    }

    if (dt.dataSource === 'internal') {
      return;
    }

    if( dt.selectAllItems === 'all' ){

      if(dt.dataSource === 'dataArray' || dt.dataSource === 'docArray'){
        DataTableSelect.docArray(this, dt);
      }else{
        DataTableSelect.all(this, dt);
      }
      return;
    }

    dt.deselected = true;
    dt.dontWatch = true;

    if (!dt.componentDefinition.multiSelect) {
      if(dt.dataSource === 'dataArray' || dt.dataSource === 'docArray'){
        DataTableSelect.singleSelectArray(this, dt, indexes);
      }else{
        DataTableSelect.singleSelect(this, dt, indexes);
      }
    } else {

      if(dt.dataSource === 'dataArray'){
        DataTableSelect.multiSelectArray(this, dt, indexes);
      }else{
        DataTableSelect.multiSelect(this, dt, indexes);
      }

    }

    if (!dt.componentDefinition.disableAutoDisplay) {
      dt.changeTemplateToogle = true;
    }

    // Changing the document to update after select when not multiSelect
    dt.fieldValue = dt.selectedDocumentsRel;
    this.selectedStatus(dt);

    dt.valueChanged(dt.fieldValue);
    dt.resetIntervalTimer(dt.table);
    // UtilService.safeApply(scope);

  }

  deselect(dt, indexes) {

    if (dt.dataSource === 'internal') {
      return;
    }
    dt.dontWatch = true;

    if(dt.dataSource === 'dataArray'){
      DataTableSelect.deselectArray(this, dt, indexes);

    }else{
      DataTableSelect.deselect(this, dt, indexes);
    }


    this.selectedStatus(dt);

    // Changing the document to update after deselect
    if (dt.selectedDocumentsRel.length === 0) {
      delete dt.fieldValue;
    } else {
      dt.fieldValue = dt.selectedDocumentsRel;
    }
    dt.resetIntervalTimer(dt.table);
    // logger.info("Datatable Row has been unselected " + type);

    if (indexes.indexOf(dt.lastSelectedIndex) !== -1 || !dt.fieldValue) {
      dt.showChildDocTitle = false;
      dt.deselected = false;
    }
    dt.changeTemplateToogle = false;

    dt.valueChanged(dt.fieldValue);
    dt.detectChanges();

  }

  selectAll(dt, selectAll?: string) {

    if (!dt.componentDefinition.multiSelect) {
      dt.notificationService.printMessage('"multiSelect" option must be set to true.', 'error');
      return false;
    }

    if (selectAll === dt.selectAllItems) {
      return;
    }

    if( !dt.componentDefinition.noClearBeforeSelectAll ){
      dt.selectedDocumentsRel = [];
    }

    dt.selectAllItems = selectAll;

    $(dt.table.body()).css('pointerEvents', 'none');
    $(dt.dtWrapper.nativeElement).find('.dataTables_processing').show();

    dt.table.rows().select();
  }

  deselectAll(dt) {
      dt.table.rows().deselect();

      dt.selectedDocumentsRel = [];
      dt.selectedDocumentSource = [];
      dt.selectAllItems = false;
      dt.selectAllBox = false;

      // Changing the document to update after select when not multiSelect
      dt.fieldValue = dt.selectedDocumentsRel;
      dt.valueChanged(dt.fieldValue);

      this.selectedStatus(dt);
  }

  selectedStatus(dt) {
    if (dt.selectedDocumentsRel.length === 0) {
      dt.selectedStatusDisplay = dt.isSelectionView;
      dt.selectedStatusLabel = '';
    } else {
      dt.selectedStatusDisplay = true;
      const rowStr = dt.selectedDocumentsRel.length + ' ' + (dt.selectedDocumentsRel.length === 1 ? 'row' : 'rows');
      dt.selectedStatusLabel = sclHandlebars.processHandlebars(dt.SELECTED_STATUS_LABEL, {numRows: rowStr}, null);
    }

    dt.detectChanges();
  }

  columnReorder(dt, details) {
    dt.columnIndex = this.columnMove(dt.columnIndex, details.from, details.to);
    dt.excludeResizeCol = this.updatedColResize(dt.initialResizeCol, dt.columnIndex);
    dt.sclDatatableResponsiveService.checkColHidden(dt.fieldName);

    // Clean and Update the last visible column
    const dtObj = $(dt.divChildTemplate.nativeElement).find('table.dataTable');
    this.markLastColumn(dtObj);

    // logger.info("Datatable moved. Reinitialize column resizing...");
  }

  showChildRow(dt, e, row) {
      const currentRow = $(e.target).parents().closest('tr');
      currentRow.addClass('dt-parent');

      const hiddenCols = $(row).find('td:hidden').toArray();
      const hiddenHeaderCols = $(row).parents('table').find('thead tr:first-child th:hidden').toArray();

      const newRow = $('<tr>').addClass('dt-child-row');
      const colCount = dt.columns()[0].length;

      const newCell = $('<td>').attr('colspan', colCount - hiddenCols.length);

      const list = $('<ul>');
      $(row).find('td:hidden').each( (key, el) => {
          const li = $('<li>');
          const title = $(hiddenHeaderCols[key]).html();
          const data = $(el).html();
          li.append(`<span>${title}</span><span>${data}</span>`);
          list.append(li);
      });

      newCell.append(list);
      newRow.append(newCell);
      newRow.insertAfter(currentRow);
  }

  private columnMove(arr, oldIndex, newIndex) {
    if (newIndex >= arr.length) {
      let k = newIndex - arr.length + 1;
      while (k--) {
        arr.push(undefined);
      }
    }
    arr.splice(newIndex, 0, arr.splice(oldIndex, 1)[0]);
    return arr;
  }

  private updatedColResize(oldCol, newCol) {
    const updatedCol = [];

    for (const colOld of oldCol) {
      for (const [j, colNew] of newCol.entries()) {
        if ( colOld === colNew ) {
          updatedCol.push(j);
          break;
        }
      }
    }

    return updatedCol;
  }

  public initializeResize(dt){
      let pressed = false;
      let start;
      let startX;
      let startWidth;
      let nextStartWidth;
      let initWidth = 0;
      let maxWidth = 0;
      let p;
      let resizedTable;

    $('.dt-resizer').on('mousedown touchstart', (e) => {
        e.stopPropagation();
        e.preventDefault();

        const touch = e.originalEvent.touches ? e.originalEvent.touches[0] : null;
        const pageX = touch ? touch.pageX : e.pageX;

        p = $(e.target).parent();
        resizedTable = $(dt.divChildTemplate.nativeElement).find('table.dataTable');
        start = p;
        pressed = true;
        startX = pageX;
        startWidth = p.width();
        nextStartWidth = p.next().width();
        initWidth = startWidth;
        maxWidth = calculateMaxWidth();
        p.addClass('disableClick');
        resizedTable.addClass('column-resizing');
      });

    const calculateMaxWidth = () => {
      return p.width() + p.nextAll('th:visible').first().width();
    };

    $(document).on('mousemove touchmove', (e) => {
        if (pressed) {

          const touch = e.originalEvent.touches ? e.originalEvent.touches[0] : null;
          const pageX = touch ? touch.pageX : e.pageX;

          const newWidth = startWidth + (pageX - startX);
          const nextNewWidth = nextStartWidth - (pageX - startX);
          if (newWidth <= maxWidth - 10 && nextNewWidth <= maxWidth - 10) {
            $(start).width(newWidth);
            $(start).nextAll('th:visible').first().width(nextNewWidth)
          }
        }
      });

    $(document).on('mouseup touchend', (e) => {
        if (pressed) {
          pressed = false;
        }
        if (p) {
          p.removeClass('disableClick');
        }
        if(resizedTable){
          resizedTable.removeClass('column-resizing');
        }
        e.stopPropagation();
      });
  }

  public markLastColumn(dtElem){
    // remove last-child class
    dtElem.find('thead tr:first-child th.dt-last-child').removeClass('dt-last-child');
    // add last-child class
    dtElem.find('thead tr:first-child th:visible:last').addClass('dt-last-child');
  }

}
